/* @flow */

import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import QuoteRegular from './quote-regular-icon.svg';

function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <QuoteRegular {...validProps} />;
}

SvgComponent.iconName = 'quoteRegular';

export const QuoteRegularIcon = svgIconWrapper(SvgComponent);
